module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ge-Hc-Ib-Jb.7fff7631.png";